const localizers = {
  'loading.msg': () => `Učitavanje...`,
  'logon.message.msg': () => `Obavezna je potvrda identiteta. Unesite važeći korisnički ID i lozinku.`,
  'logon.button.msg': () => `Prijavljivanje...`,
  'SASServer.logonError.msg': () => `Prijavljivanje na server nije moguće.`,
  'SASServer.genericError.msg': () => `Nije moguće uspostaviti vezu sa serverom.`,
}
export default localizers;
